import React from "react";
import { TriangleAlert, Lock, ShieldAlert, CloudLightning, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
const situations = [{
  title: "Lavoro Subordinato e Stagionale",
  description: "Gestione completa delle pratiche per l'ingresso di lavoratori dipendenti, stagionali e conversioni di permessi di soggiorno esistenti.",
  linkText: "Scopri i Requisiti",
  linkUrl: "/Contacts",
  icon: TriangleAlert
}, {
  title: "Nomadi Digitali",
  description: "Percorsi agevolati per lavoratori altamente qualificati e professionisti remoti che desiderano stabilirsi e lavorare in Italia.",
  linkText: "Verifica Eleggibilità",
  linkUrl: "/Contacts",
  icon: Lock
}, {
  title: "Investitori e Start-Up (ICT)",
  description: "Supporto per visti investitori, programmi start-up e trasferimenti intra-societari per dirigenti e personale specializzato.",
  linkText: "Pianifica Investimento",
  linkUrl: "/Contacts",
  icon: ShieldAlert
}, {
  title: "Ricerca e Formazione",
  description: "Procedure per ricercatori, tirocinanti e programmi di formazione professionale per lo sviluppo di competenze internazionali.",
  linkText: "Dettagli Programma",
  linkUrl: "/Contacts",
  icon: CloudLightning
}, {
  title: "EU Blue Card",
  description: "Gestione dedicata per lavoratori altamente qualificati extra-UE: semplifico ogni passaggio burocratico per garantirti un inserimento rapido e senza intoppi.",
  linkText: "Scopri Vantaggi",
  linkUrl: "/Contacts",
  icon: ArrowRight
}, {
  title: "Lavoro Autonomo",
  description: "Gestione delle pratiche di visto d'ingresso per il lavoro autonomo in Italia.",
  linkText: "Scopri i Requisiti",
  linkUrl: "/Contacts",
  icon: TriangleAlert
}, {
  title: "Permesso soggiorno per lavoro",
  description: "Richiesta, conversione permesso soggiorno per motivi di lavoro, autonomo, subordinato, lavoro altamente qualificato,",
  linkText: "Scopri i Requisiti",
  linkUrl: "/Contacts",
  icon: ArrowRight
}, {
  title: "CONSULENZA SPECIALIZZATA",
  description: "Analisi tecnica e assistenza operativa per l'individuazione della corretta tipologia di visto e la corretta istruzione della pratica per ogni categoria di ingresso per lavoro.",
  linkText: "Richiedi Consulenza",
  linkUrl: "/Contacts",
  icon: ShieldAlert
}];
export default function EmergencySituationsGrid() {
  return <section data-section-id="257321" id="workvisasservices" className="py-20 md:py-28 bg-background text-foreground">
      <div className="page-container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-secondary font-default font-semibold tracking-wider text-sm uppercase mb-4 block">
            I Nostri Servizi
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary mb-6">
            Soluzioni per il Visto Lavoro
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Offriamo consulenza specialistica per ogni tipologia di ingresso lavorativo in Italia, garantendo conformità normativa e velocità burocratica.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {situations.map((item, i) => {
          const Icon = item.icon;
          return <Card key={i} data-index={i} className="h-full border border-border shadow-sm hover:shadow-lg transition-all duration-300 bg-card rounded-md">
                <CardContent className="flex flex-col h-full">
                  <div className="w-12 h-12 rounded-md bg-secondary/10 flex items-center justify-center mb-6 text-secondary shrink-0">
                    <Icon className="w-6 h-6" />
                  </div>
                  
                  <h3 className="font-default font-bold text-xl text-primary mb-3">
                    {item.title}
                  </h3>
                  
                  <p className="text-muted-foreground text-sm leading-relaxed font-default flex-grow mb-8">
                    {item.description}
                  </p>
                  
                  <Link to={item.linkUrl} className="text-primary font-semibold text-sm flex items-center gap-2 hover:text-secondary transition-colors mt-auto w-fit group">
                    {item.linkText} 
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}